/**
 * Провайдер для синхронизации языка между Redux и i18n
 * Заменяет LanguageContext
 */
import React, { useEffect } from 'react';
import { useAppSelector } from '../redux/hooks';
import i18n from './i18n';

/**
 * Компонент для синхронизации языка между Redux, i18n и cookie/localStorage
 */
const ReduxLanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const currentLanguage = useAppSelector(state => state.language.currentLanguage);

    // Синхронизация i18n с Redux состоянием при изменениях
    useEffect(() => {
        if (i18n.language !== currentLanguage) {
            i18n.changeLanguage(currentLanguage);
        }
    }, [currentLanguage]);

    // Синхронизация при изменениях в других вкладках (localStorage)
    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === 'i18nextLng' && event.newValue !== currentLanguage) {
                // Изменения будут обработаны в соответствующих редьюсерах
                // при диспатче действий из компонентов
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [currentLanguage]);

    return <>{children}</>;
};

export default ReduxLanguageProvider; 